import './geo.css';
import { useRef, useState, useEffect, useCallback } from 'react';

import { FaFacebookSquare, FaInstagram } from "react-icons/fa";
import { SlGlobe } from "react-icons/sl";
import { IoLogoYoutube } from "react-icons/io5";

import { SeeAllButton } from '../../../components/seeallbutton/SeeAll';
import { geos } from './geoData.js';

export function Geo() {
  const sliderRef = useRef(null);
  const [positionTree, setPositionTree] = useState(0);
  const [, setSlideWidth] = useState(0);

  const [expanded, setExpanded] = useState(false);

  const [viewItemsTree, setViewItemsTree] = useState(
    window.innerWidth <= 600 ? 3 :
    window.innerWidth <= 800 ? 4 : 
    window.innerWidth <= 1000 ? 5 : 7
  );

  useEffect(() => {
  const handleResize = () => {
    if (expanded) {
      // ✅ Expanded mode breakpoints
      if (window.innerWidth <= 600) {
        setViewItemsTree(3);
      } else if (window.innerWidth <= 800) {
        setViewItemsTree(5); // ✅ force 5 instead of 4
      } else if (window.innerWidth <= 1000) {
        setViewItemsTree(6);
      } else {
        setViewItemsTree(7);
      }
    } else {
      // ✅ Collapsed mode breakpoints
      if (window.innerWidth <= 600) {
        setViewItemsTree(3);
      } else if (window.innerWidth <= 800) {
        setViewItemsTree(4);
      } else if (window.innerWidth <= 1000) {
        setViewItemsTree(5);
      } else {
        setViewItemsTree(7);
      }
    }
  };

  handleResize(); // run once on mount/expand toggle
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, [expanded]);

  const updateSlider = useCallback(() => {
    if (sliderRef.current) {
      const width = sliderRef.current.clientWidth / viewItemsTree;
      setSlideWidth(width);
      sliderRef.current.style.transform = `translateX(-${positionTree * width}px)`;
    }
  }, [positionTree, viewItemsTree]);

  useEffect(() => {
    updateSlider();
    window.addEventListener('resize', updateSlider);
    return () => window.removeEventListener('resize', updateSlider);
  }, [updateSlider]);

  const totalItems = geos.length;

  const handleLeftClick = () => {
    if (positionTree > 0) {
      setPositionTree(prev => prev - 1);
    }
  };

  const handleRightClick = () => {
    if (positionTree < totalItems - viewItemsTree) {
      setPositionTree(prev => prev + 1);
    }
  };

  const handleExpand = () => {
    setExpanded(prev => !prev);
    setPositionTree(0); // reset slider position
  };

  return (
    <div className="main">
      <div className={`geo ${expanded ? 'expanded' : ''}`}>

        <div className="slider-container">
          <div
            className={`geo-img tree-img container ${expanded ? 'expanded' : ''}`}
            ref={sliderRef}
            style={{ transition: 'transform 0.7s ease' }}
          >
            {geos.map((ngo, index) => (
              <div key={index} className="my-div" style={{ width: expanded ? "auto" : `calc(100% / ${viewItemsTree})` }}>
                <div className="img-container">
                  <img src={ngo.logo} alt={ngo.alt} />
                  <div className="icons">
                    {ngo.links.website && (
                      <a href={ngo.links.website} target="_blank" rel="noopener noreferrer">
                        <SlGlobe className='first' />
                      </a>
                    )}
                    {ngo.links.facebook && (
                      <a href={ngo.links.facebook} target="_blank" rel="noopener noreferrer">
                        <FaFacebookSquare className='second' />
                      </a>
                    )}
                    {ngo.links.instagram && (
                      <a href={ngo.links.instagram} target="_blank" rel="noopener noreferrer">
                        <FaInstagram className='third' />
                      </a>
                    )}
                    {ngo.links.youtube && (
                      <a href={ngo.links.youtube} target="_blank" rel="noopener noreferrer">
                        <IoLogoYoutube className='fourth' />
                      </a>
                    )}
                  </div>
                </div>
                <p className='h2'>{ngo.title}</p>
              </div>
            ))}
          </div>
        </div>

        <SeeAllButton onClick={handleExpand} isExpanded={expanded} />


      </div>

      {!expanded && (
        <>
          <button className='one' onClick={handleLeftClick} disabled={positionTree === 0}>
            &#8810;
          </button>
          <button className='two' onClick={handleRightClick} disabled={positionTree >= totalItems - viewItemsTree}>
            &#8811;
          </button>
        </>
      )}
    </div>
  );
}